import {Trans} from '@lingui/macro';
import React from 'react';

import {AppPanelId} from '../../../store/panels/panelStateBase';
import {
  CarouselSlideContent,
  CarouselSlideContentLeft,
  CarouselSlideContentProps,
  CarouselSlideDefinition,
  CarouselSlideDescription,
  CarouselSlideTitle,
} from '../carouselCommon';
import {WelcomeCarouselCompanyFormContainer} from './forms/welcomeCarouselCompanyFormContainer';

/*
 * Props.
 */

interface WelcomeCarouselCompanySlideProps {
  panelId: AppPanelId;
}

/*
 * Helpers.
 */

function renderContent(props: WelcomeCarouselCompanySlideProps, contentProps: CarouselSlideContentProps) {
  const {panelId} = props;
  const {index, onPreviousClick, onNextClick} = contentProps;

  return (
    <CarouselSlideContent key={index}>
      <CarouselSlideContentLeft>
        <CarouselSlideTitle>
          <Trans id="welcomecarousel-company-title">Company details</Trans>
        </CarouselSlideTitle>
        <CarouselSlideDescription>
          <Trans id="welcomecarousel-company-description">
            Since your company is new to Front, tell us a bit more.
          </Trans>
        </CarouselSlideDescription>
      </CarouselSlideContentLeft>
      <WelcomeCarouselCompanyFormContainer
        panelId={panelId}
        onPreviousClick={onPreviousClick}
        onCompleteForm={onNextClick}
      />
    </CarouselSlideContent>
  );
}

/*
 * Slide defintion.
 */

export function makeWelcomeCarouselCompanySlide(
  props: WelcomeCarouselCompanySlideProps,
): CarouselSlideDefinition {
  return {
    renderContent: (contentProps) => renderContent(props, contentProps),
  };
}
